import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{staticClass:"hidden-xs-only",attrs:{"color":"success","timeout":1500,"bottom":"","right":"","id":"main_snack_bar"},model:{value:(_vm.authSnackbar),callback:function ($$v) {_vm.authSnackbar=$$v},expression:"authSnackbar"}},[_c(VIcon,{staticClass:"mr-3"},[_vm._v("check_cricle")]),_c('h5',[_vm._v("You are now signed in!")]),_c(VBtn,{attrs:{"dark":"","text":""},on:{"click":function($event){_vm.authSnackbar = false}}},[_vm._v("Close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }